import { OrganizationMembership_OrganizationRole } from "./organization-membership_organization-role";

interface OrganizationRoleData {
  id?: number;
  name?: string;
  description?: string;
  organizationMembership_OrganizationRoles?: OrganizationMembership_OrganizationRole;
}

export class OrganizationRole {
  public static readonly ID_ADMIN: number = 1;
  public static readonly ID_SUPERCOACH: number = 2;
  public static readonly ID_COACH: number = 3;
  public static readonly ID_ATHLETE: number = 4;
  public static readonly ID_GUEST: number = 5;

  public static getNonTranslatableFields(): string[] { return ['id']; }
  public static getTranslatableFields(): string[] { return ['name', 'description']; }
  public static getFields(): string[] { return ['id', 'name', 'description']; }
  public static getKeyFields(): string[] { return ['id']; }

  id?: number;
  name?: string;
  description?: string;

  organizationMembership_OrganizationRoles?: OrganizationMembership_OrganizationRole;


  public static fromAPI(data: any, translationsData: any[]): OrganizationRole {
    let translationData: any = {};
    for (let i = 0; i < translationsData.length; i++) {
      if (translationsData[i]['organizationRoleId'] === data['id']) {
        translationData = translationsData[i];
        i = translationsData.length;
      }
    }
    if(data.organizationMembership_OrganizationRoles) {
      data.organizationMembership_OrganizationRoles = OrganizationMembership_OrganizationRole.fromAPIList(data.organizationMembership_OrganizationRoles);
    }
    return new OrganizationRole({
      id: data.id,
      name: translationData.name ?? data.name,
      description: translationData.description ?? data.description
    });
  }

  public static fromAPIList(data: OrganizationRoleData[], translationsData: any[]): OrganizationRole[] {
    return data.map((item: OrganizationRoleData) => OrganizationRole.fromAPI(item, translationsData));
  }

  constructor({id, name, description, organizationMembership_OrganizationRoles} : OrganizationRoleData) {
    this.id = id;
    this.name = name;
    this.description = description;

    this.organizationMembership_OrganizationRoles = organizationMembership_OrganizationRoles;
  }

  public toJson(): Object {
    return {
      id: this.id,
      name: this.name,
      description: this.description
    };
  }

}
